import { ReactElement } from 'react';
import { HeadTag } from 'shared/components';
import UserDetailsForm from '../profile/components/UserDetailsForm';

const UserDetailPage = (): ReactElement => (
    <>
        <HeadTag title="User Details" />
        <UserDetailsForm />
    </>
);

export default UserDetailPage;
